// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../startOfWeekYear/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var startOfWeekYearWithOptions = convertToFP(fn, 2);
export default startOfWeekYearWithOptions;